import { Step as ModelStep } from "@redotech/redo-return-core-common/return-flow";
import { blockFromModel } from "@redotech/redo-return-core-common/return-flow-step-from-model";
import {
  BlockState,
  isBlockStepValid,
} from "@redotech/redo-return-core-common/return-flow-step-valid";
import { STEP_TYPE_NAMES } from "@redotech/redo-return-core-common/return-flow/step-type-names";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import CancelIcon from "@redotech/redo-web/icon-old/octagon.svg";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const BLOCK = (
  Details: React.ComponentType<StepTypeDetailsProps<BlockState>>,
): StepType<BlockState, ModelStep.Block> => ({
  Details: (props: StepTypeDetailsProps<BlockState>) =>
    React.createElement(Details, props),
  customTitle(state) {
    return state.customTitle;
  },
  description(state) {
    return state.message;
  },
  downstream() {
    return [];
  },
  maxDownstream() {
    return 0;
  },
  empty: { message: "" },
  layout() {
    return BlockLayout.FULL;
  },
  stepDeleted(state) {
    return state;
  },
  title: STEP_TYPE_NAMES[ModelStep.BLOCK],
  valid(state) {
    return isBlockStepValid(state).valid;
  },
  fromModel(model) {
    return blockFromModel(model);
  },
  toModel(state) {
    return {
      stepUUID: state.stepUUID,
      customTitle: state.customTitle,
      type: ModelStep.BLOCK,
      message: state.message,
    };
  },
  Icon: CancelIcon,
  iconColor: "success",
});
